const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

  if (isLocalhost) {
    checkValidSW(swUrl);
  } else {
    registerSW(swUrl);
  }
}

function registerSW(swUrl) {
  navigator.serviceWorker.register(swUrl).then((reg) => {
    reg.onupdatefound = () => {
      const sw = reg.installing;
      if (!sw) return;
      sw.onstatechange = () => {
        if (sw.state === 'installed' && navigator.serviceWorker.controller) {
          // New version available — activate immediately on next navigation
          sw.postMessage({ type: 'SKIP_WAITING' });
        }
      };
    };
  }).catch((err) => {
    console.error('[SW] Registration failed:', err);
  });

  // When a new SW takes over, reload to get fresh assets
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) { refreshing = true; window.location.reload(); }
  });
}

function checkValidSW(swUrl) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((res) => {
      const notSW = res.status === 404 || !res.headers.get('content-type')?.includes('javascript');
      if (notSW) {
        navigator.serviceWorker.ready.then((reg) => reg.unregister()).then(() => window.location.reload());
      } else {
        registerSW(swUrl);
      }
    })
    .catch(() => console.log('[SW] Offline — serving cached app'));
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
